import { useToast } from '@chakra-ui/react';
import * as DialogRadix from '@radix-ui/react-dialog';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { Cross2Icon } from '@radix-ui/react-icons';
import * as RadioGroup from '@radix-ui/react-radio-group';
import { format, getTime } from 'date-fns';
import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useRef,
  useState
} from 'react';
import { CiCalendar } from 'react-icons/ci';
import { IoIosArrowDown } from 'react-icons/io';
import MaskedInput from 'react-text-mask';

import { DatePickerExport } from '../../../../../components/datepicker/DatePickerExport';
import FilterContext from '../../../../../contexts/FilterContext';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { getProductName } from '../../../../../utils/leads.util';

type Seller = {
  id: string;
  codigo_produtor: string;
  nome: string;
  login: string;
};
type DialogProps = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  type?: string;
  sellers?: Seller[] | null;
  tipoConsultaCampanhas?: string;

  handleExport?: (formatFilters: any) => Promise<void>;
};

const KanbanFiltersModal = ({
  isOpen,
  setIsOpen,
  handleExport,
  type,
  sellers,
  tipoConsultaCampanhas
}: DialogProps) => {
  const cpf = [
    /[0-9]/,
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/
  ];

  const cnpj = [
    /[0-9]/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '/',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/
  ];

  const products = [
    'Odonto',
    'Saúde',
    'Saúde PRC',
    'Saúde + Odonto',
    'Viagem',
    'VIAGEM',
    'Vida',
    'Previdência',
    'Vida Coletivo',
    'Odonto Empresa'
  ];

  const failedReasons = [
    {
      status: 'lgpd-bloqueado',
      text: 'Bloqueado para contato; (LGPD) cliente diz não ter solicitado contato'
    },
    {
      status: 'nao-responde',
      text: 'Não responde | sem interação nos contatos realizados'
    },
    {
      status: 'dados-invalidos',
      text: 'Dados inválidos'
    },
    {
      status: 'preco',
      text: 'Preço'
    },
    {
      status: 'fora-rede',
      text: 'Fora da rede credenciada | Fora da área de abrangência | Localização'
    },
    {
      status: 'concorrencia',
      text: 'Concorrência | Fechou com outra Seguradora | Atendido por outro Corretor'
    },
    {
      status: 'cnpj-inativo',
      text: 'CNPJ inativo | Emissão de certidão negativa'
    },
    {
      status: 'mei-menos',
      text: ' MEI menos de 6 meses'
    },
    {
      status: 'pj-1-vida',
      text: ' PJ para 1 vida'
    },
    {
      status: 'ja-contratou',
      text: 'Já contratou'
    },
    {
      status: 'converteu-saude',
      text: 'Interesse em outros produtos | Converteu Saúde'
    },
    {
      status: 'converteu-odonto',
      text: 'Interesse em outros produtos | Converteu Odonto'
    },
    {
      status: 'converteu-vida',
      text: 'Interesse em outros produtos | Converteu Vida'
    },
    {
      status: 'converteu-viagem',
      text: 'Interesse em outros produtos | Converteu Viagem'
    },
    {
      status: 'sem-interesse',
      text: 'Não teve interesse'
    },
    {
      status: 'recusa-sula',
      text: 'Recusa SulAmérica DPS'
    }
  ];

  const typeSearch = [
    { text: 'Nome', id: 'NOME__c' },
    { text: 'Email', id: 'EMAIL__c' },
    { text: 'Telefone', id: 'TELEFONE__c' },
    { text: 'Celular', id: 'CELULAR__c' }
  ];

  const motivosSaude = [
    'Prestige',
    'Executivo',
    'Especial Mais',
    'Especial 100',
    'Clássico',
    'Exato',
    'Direto Nacional',
    'Direto Regional'
  ];

  const motivosVida = [
    'Acidentes pessoais',
    'Acidentes pessoais estagiários',
    'Vida simples',
    'Vida individual e Mulher',
    'Viagem',
    'Capital Global',
    'Você empresa',
    'Prestamista'
  ];
  const motivosOdonto = ['Individual', 'PME', 'PME MAIS', 'Empresarial'];
  const { filterObject, setFilterObject, loadingFilters, setExportObject } =
    useContext(FilterContext);
  const [campaigns, setCampaigns] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState('Selecione o produto');
  const [loading, setLoading] = useState(false);
  const [selectedProductNovo, setSelectedProductNovo] = useState(
    'Selecione o produto'
  );
  const mobileRef = useRef(0);
  const [selectedPlano, setSelectedPlano] = useState('Selecione o plano');
  const [approach, setApproach] = useState(null);
  const [approachN2, setApproachN2] = useState(null);
  const [sellerInfo, setSellerInfo] = useState({
    id: '',
    nome: 'Selecione o vendedor',
    codigo_produtor: '',
    login: ''
  });
  const [status, setStatus] = useState(null);
  const toast = useToast();
  const [selectedTextType, setSelectedTextType] = useState(typeSearch[0]);
  const [selectedFailedReason, setSelectedFailedReason] =
    useState('Selecione o motivo');
  const [selectedCampaign, setSelectedCampaign] = useState(
    'Selecione uma campanha'
  );
  const [canFilter, setCanFilter] = useState(true);
  const [radiobox, setRadiobox] = useState('');
  const [radioboxVisualization, setRadioboxVisualization] = useState('');

  const [openDatePicker, setOpenDatePicker] = useState(false);

  const [leadInfo, setLeadInfo] = useState({
    documento: '',
    contato: ''
  });
  const [startDate, setStartDate] = useState(null);
  const [schelludingDate, setSchelludingDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const sendFilters = async () => {
    const formatFilters = {
      query: {
        status,
        'data-inicial': startDate
          ? getTime(new Date(startDate)).toString()
          : null,
        'data-final': startDate ? getTime(new Date(endDate)).toString() : null,
        campanha:
          selectedCampaign === 'Selecione uma campanha'
            ? null
            : selectedCampaign,
        'abordagem-n2': approachN2,
        'produto-atual':
          selectedProduct === 'Selecione o produto' ? null : selectedProduct,
        produto:
          selectedProductNovo === 'Selecione o produto'
            ? null
            : selectedProductNovo,
        abordagem: approach,
        nome:
          selectedTextType.id === 'NOME__c' ? leadInfo.contato?.trim() : null,
        email:
          selectedTextType.id === 'EMAIL__c' ? leadInfo.contato?.trim() : null,
        telefone:
          selectedTextType.id === 'TELEFONE__c'
            ? leadInfo.contato?.trim()
            : null,
        celular:
          selectedTextType.id === 'CELULAR__c'
            ? leadInfo.contato?.trim()
            : null,
        plano: selectedPlano === 'Selecione o plano' ? null : selectedPlano,
        'data-agendamento': schelludingDate === null ? null : schelludingDate,
        visualizacao: radioboxVisualization ? radioboxVisualization : null
      },
      headers: {
        login: sellerInfo.id || filterObject.headers.login || null,
        cpf: leadInfo.documento?.length <= 14 ? leadInfo.documento : null,
        cnpj: leadInfo.documento?.length > 14 ? leadInfo.documento : null
      }
    };

    for (const filter in formatFilters) {
      if (formatFilters[filter] === null || formatFilters[filter] === '') {
        delete formatFilters[filter];
      }
    }

    console.log(formatFilters);
    //Setar objeto para requisição da função no kanban
    try {
      if (type === 'filtrar') {
        setLoading(true);
        setFilterObject(formatFilters);
      } else if (type === 'exportar') {
        setLoading(true);
        toast({
          position: 'top',
          description:
            'Por favor, não feche esta página. Estamos processando o arquivo',
          status: 'warning',
          duration: 4000,
          isClosable: true
        });
        await handleExport(formatFilters);

        setExportObject(formatFilters);
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
    }
  };

  const clearFilter = () => {
    setRadiobox('');
    setLeadInfo({
      documento: '',
      contato: ''
    });
    setSellerInfo({
      id: '',
      nome: 'Selecione o vendedor',
      codigo_produtor: '',
      login: ''
    });
    setStartDate(null);
    setEndDate(null);
    setStatus(null);
    setApproach(null);
    setApproachN2(null);
    setSelectedProduct('Selecione o produto');
    setSelectedProductNovo('Selecione o produto');
    setSelectedCampaign('Selecione uma campanha');
    setSelectedFailedReason('Selecione o motivo');
    setSelectedPlano('Selecione o plano');
    setSelectedProduct('Selecione o produto');
    setRadioboxVisualization('');
    setSchelludingDate(null);
    setStartDate(null);
    setEndDate(null);
  };

  const switchPlans = (product) => {
    switch (product) {
      case 'Odonto':
        return motivosOdonto;
      case 'Saúde':
        return motivosSaude;
      case 'Saúde + Odonto':
        return [];
      case 'Viagem':
        return [];
      case 'Vida':
        return motivosVida;
      case 'Previdência':
        return [];
      default:
        return [];
    }
  };

  const getCampaignsData = async () => {
    let looping = true;
    while (looping) {
      try {
        const { data } = await apiSensedia.get(
          `oportunidades-sulamerica/painel-leads/leads/campanhas`,
          {
            params: {
              'tipo-consulta': tipoConsultaCampanhas
            }
          }
        );
        setCampaigns(data);
        looping = false;
      } catch (e: any) {
        if (e.response.status == 500) {
          console.log('ocorreu internal server error', e.response.statusText);
          console.log('ocorreu internal server error', e.response.data);
        } else if (e.response.status == 504) {
          console.log('ocorreu gateway timeout', e.response.data);
        }
        if (e.response.status !== 504) {
          looping = false;
        }
      }
    }
  };

  useEffect(() => {
    if (isOpen) getCampaignsData();
  }, [isOpen]);

  useEffect(() => {
    if (loadingFilters === false) {
      setIsOpen(false);
      setLoading(false);
    }
  }, [loadingFilters]);
  useEffect(() => {
    mobileRef.current = window.innerWidth;
  }, []);
  return (
    <DialogRadix.Root open={isOpen} onOpenChange={setIsOpen}>
      <DialogRadix.Portal>
        <div className="tw-fixed tw-inset-0 tw-bg-gray-500 tw-bg-opacity-75 tw-transition-opacity"></div>
        <DialogRadix.Content className="data-[state=open]:animate-contentShow tw-fixed lg:tw-max-h-[95vh] mb:tw-max-h-[100vh] tw-top-[50%] tw-left-[50%] sm:tw-w-[65vw] mb:tw-w-full tw-translate-x-[-50%] tw-translate-y-[-50%] tw-rounded-[1rem] tw-bg-white tw-p-[25px] tw-shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] tw-focus:outline-none mb:tw-overflow-scroll mb:tw-overflow-x-hidden sm:tw-overflow-auto sm:tw-overflow-x-auto">
          <DialogRadix.Title className="tw-text-mauve12 tw-text-start tw-m-0 tw-text-[17px] tw-font-medium">
            {type === 'exportar' ? 'Exportar Leads' : 'Filtrar Leads'}
          </DialogRadix.Title>
          {/* Separator */}
          <div className="tw-flex tw-py-2 tw-items-center tw-w-[100%]">
            <div className="tw-flex-grow tw-border-t tw-border-gray-300"></div>
          </div>
          <div className="tw-overflow-scroll tw-overflow-x-hidden sm:tw-h-[52vh] lg:tw-h-[65vh]">
            {/* Input cpf/cnpj */}
            <div className="tw-flex tw-w-[100%] tw-justify-between tw-gap-4">
              <div className="tw-flex tw-flex-col tw-w-[100%] tw-p-4 tw-bg-[#F4F4F4] tw-rounded-md">
                <span className="tw-font-bold">CPF/CNPJ do lead</span>
                <MaskedInput
                  mask={leadInfo.documento.length <= 14 ? cpf : cnpj}
                  guide={false}
                  value={leadInfo.documento}
                  placeholder={'Digite CPF/CNPJ'}
                  onChange={(e) => {
                    setLeadInfo({ ...leadInfo, documento: e.target.value });
                  }}
                  className="tw-w-[100%] tw-px-2 tw-h-[2.5rem] tw-border-[0.1rem] tw-border-[#001E64] tw-rounded-md"
                />
              </div>
            </div>
            {/* Inputs contato do lead */}
            <div className="tw-flex tw-flex-col tw-w-[100%] tw-p-4 tw-mt-4 tw-bg-[#F4F4F4] tw-rounded-md">
              <span className="tw-font-bold">
                Contato do lead{' '}
                <span className="tw-font-normal tw-text-[0.8rem] tw-text-[#001E64]">
                  (Buscar por e-mail, nome ou telefone)
                </span>
              </span>
              <div className="tw-flex tw-gap-2">
                <DropdownMenu.Root>
                  <DropdownMenu.Trigger asChild>
                    <button
                      className="tw-pl-1 tw-w-[14rem] tw-text-white tw-border-black tw-border-[0.1rem] tw-rounded-full tw-h-10 "
                      aria-label="Customise options"
                    >
                      <span className="tw-pl-1 tw-flex tw-text-[1rem] tw-font-bold tw-items-center tw-justify-between tw-px-2">
                        <span className={'tw-text-black'}>
                          {selectedTextType.text}
                        </span>
                        <IoIosArrowDown color="black" />
                      </span>
                    </button>
                  </DropdownMenu.Trigger>

                  <DropdownMenu.Portal>
                    <DropdownMenu.Content
                      className="tw-px-4 tw-py-2 tw-bg-white tw-rounded-md tw-p-[5px] tw-shadow-md tw-font-[1.1rem]"
                      sideOffset={5}
                    >
                      <DropdownMenu.Item
                        onClick={() => {
                          setSelectedProduct('Selecione o produto');
                          setSelectedTextType(typeSearch[0]);
                        }}
                        className="hover:tw-bg-slate-200 tw-w-[100%] tw-font-bold tw-cursor-pointer"
                      >
                        Selecione o tipo:
                      </DropdownMenu.Item>
                      {typeSearch.map((type, index) => {
                        return (
                          <DropdownMenu.Item
                            defaultChecked={type.id === 'NOME__c'}
                            key={index}
                            onClick={() => {
                              setSelectedProduct('Selecione o produto');
                              setSelectedTextType(type);
                            }}
                            className="hover:tw-bg-slate-200 tw-w-[100%] tw-cursor-pointer"
                          >
                            {type.text}
                          </DropdownMenu.Item>
                        );
                      })}
                    </DropdownMenu.Content>
                  </DropdownMenu.Portal>
                </DropdownMenu.Root>
                <input
                  className="tw-w-[100%] tw-px-2 tw-h-[2.5rem] tw-border-[0.1rem] tw-border-[#001E64] tw-rounded-md"
                  placeholder="Buscar por e-mail, nome ou telefone."
                  value={leadInfo.contato}
                  onChange={(e) => {
                    setLeadInfo({ ...leadInfo, contato: e.target.value });
                  }}
                />
              </div>
            </div>
            {/* Datepicker */}
            <div className="tw-flex tw-w-[100%] tw-mt-4 tw-justify-between tw-gap-4">
              <div className="tw-flex tw-flex-col tw-w-[100%] tw-p-4 tw-bg-[#F4F4F4] tw-rounded-md">
                <span className="tw-font-bold">Escolha o período</span>

                {startDate && endDate ? (
                  <button
                    onClick={() => {
                      setOpenDatePicker(!openDatePicker);
                    }}
                    className="tw-flex tw-text-white sm:tw-w-[20vw] mb:tw-w-[70%]"
                  >
                    <div className="tw-flex tw-gap-1 tw-items-center tw-h-[3rem] tw-w-full tw-rounded-l-full tw-justify-center  tw-bg-[#001E64] tw-border-[0.1rem] tw-border-[#001E64]">
                      {format(new Date(startDate), 'dd/MM/yyyy')}
                    </div>
                    <div className="tw-flex tw-gap-1 tw-items-center tw-h-[3rem] tw-w-full tw-rounded-r-full tw-justify-center  tw-bg-[#001E64] tw-border-[0.1rem] tw-border-[#001E64]">
                      {format(new Date(endDate), 'dd/MM/yyyy')}
                    </div>
                  </button>
                ) : (
                  <>
                    <button
                      onClick={() => {
                        radiobox !== 'Agendamento em atraso' &&
                          setOpenDatePicker(!openDatePicker);
                      }}
                      className="tw-flex tw-gap-1 tw-items-center tw-text-[#001E64] tw-h-[3rem] tw-rounded-full tw-justify-center sm:tw-w-[10vw] mb:tw-w-[70%] tw-border-[0.1rem] tw-border-[#001E64]"
                    >
                      <CiCalendar size={'1.2rem'} />

                      <span>Período</span>
                    </button>
                    {radiobox === 'Agendamento em atraso' && (
                      <span className="tw-py-1 tw-text-[#001E64]">
                        Desabilitado por ter selecionado status: Agendamento em
                        atraso
                      </span>
                    )}
                  </>
                )}
                <DatePickerExport
                  isMobile={mobileRef.current < 720}
                  isOpen={openDatePicker}
                  setEndDate={setEndDate}
                  setStartDate={setStartDate}
                  setIsOpen={setOpenDatePicker}
                />
              </div>
            </div>

            <div className="tw-flex tw-w-[100%] mb:tw-flex-col sm:tw-flex-row tw-justify-between tw-gap-4 tw-mt-4">
              <div className="tw-flex tw-flex-col tw-w-[100%] tw-p-4 tw-bg-[#F4F4F4] tw-rounded-md">
                <span className="tw-font-bold">Produtos</span>
                <DropdownMenu.Root>
                  <DropdownMenu.Trigger asChild className="tw-w-[100%]">
                    <button
                      className="tw-pl-1 tw-text-white tw-border-[#001E64] tw-border-[0.1rem] tw-rounded-full tw-h-10 tw-w-[100%]"
                      aria-label="Customise options"
                    >
                      <span className="tw-pl-1 tw-flex tw-text-[1rem] tw-font-bold tw-items-center tw-justify-between tw-px-2">
                        <span
                          className={
                            selectedProduct === 'Selecione o produto'
                              ? 'tw-text-[#AAAAAA]'
                              : 'tw-text-[#001E64]'
                          }
                        >
                          {selectedProduct}
                        </span>
                        <IoIosArrowDown color="#001E64" />
                      </span>
                    </button>
                  </DropdownMenu.Trigger>

                  <DropdownMenu.Portal>
                    <DropdownMenu.Content
                      className="tw-w-[22rem] tw-px-4 tw-py-2 tw-bg-white tw-rounded-md tw-p-[5px] tw-shadow-md tw-font-[1.1rem]"
                      sideOffset={5}
                    >
                      <DropdownMenu.Item
                        onClick={() => {
                          setSelectedProduct('Selecione o produto');
                        }}
                        className="hover:tw-bg-slate-200 tw-w-[100%] tw-font-bold tw-cursor-pointer"
                      >
                        Selecione o produto:
                      </DropdownMenu.Item>
                      {products.map((product, index) => {
                        return (
                          <DropdownMenu.Item
                            key={index}
                            onClick={() => {
                              setSelectedProduct(product);
                            }}
                            className="hover:tw-bg-slate-200 tw-w-[100%] tw-cursor-pointer"
                          >
                            {getProductName(product)}
                          </DropdownMenu.Item>
                        );
                      })}
                    </DropdownMenu.Content>
                  </DropdownMenu.Portal>
                </DropdownMenu.Root>
              </div>
              <div className="tw-flex tw-flex-col tw-w-[100%] tw-p-4 tw-bg-[#F4F4F4] tw-rounded-md">
                <span className="tw-font-bold">Leads por campanhas</span>
                <DropdownMenu.Root>
                  <DropdownMenu.Trigger asChild>
                    <button
                      className="tw-pl-1 tw-text-white tw-border-[#001E64] tw-border-[0.1rem] tw-rounded-full tw-h-10 tw-w-[100%]"
                      aria-label="Customise options"
                    >
                      <span className="tw-pl-1 tw-flex tw-text-[1rem] tw-font-bold tw-items-center tw-justify-between tw-px-2">
                        <span
                          className={
                            selectedCampaign === 'Selecione uma campanha'
                              ? 'tw-text-[#AAAAAA]'
                              : 'tw-text-[#001E64]'
                          }
                        >
                          {selectedCampaign}
                        </span>
                        <IoIosArrowDown color="#001E64" />
                      </span>
                    </button>
                  </DropdownMenu.Trigger>

                  <DropdownMenu.Portal>
                    <DropdownMenu.Content
                      className="tw-px-4 tw-py-2 tw-bg-white tw-rounded-md tw-p-[5px] tw-shadow-md tw-font-[1.1rem]"
                      sideOffset={5}
                    >
                      <DropdownMenu.Item
                        onClick={() => {
                          setSelectedCampaign('Selecione uma campanha');
                        }}
                        className="hover:tw-bg-slate-200 tw-w-[100%] tw-font-bold tw-cursor-pointer"
                      >
                        Selecione uma campanha:
                      </DropdownMenu.Item>
                      {campaigns.map((campaign, index) => {
                        return (
                          <DropdownMenu.Item
                            key={index}
                            onClick={() => {
                              setSelectedCampaign(campaign);
                            }}
                            className="hover:tw-bg-slate-200 tw-w-[100%] tw-cursor-pointer"
                          >
                            {campaign}
                          </DropdownMenu.Item>
                        );
                      })}
                    </DropdownMenu.Content>
                  </DropdownMenu.Portal>
                </DropdownMenu.Root>
              </div>
            </div>
            {sellers && (
              <div className="tw-flex tw-w-[100%] tw-mt-4 tw-p-4 tw-gap-12 tw-bg-[#F4F4F4] tw-rounded-md">
                <div className="tw-flex tw-w-[46.5%] tw-flex-col">
                  <span className="tw-font-bold">Vendedores</span>
                  <DropdownMenu.Root>
                    <DropdownMenu.Trigger asChild className="">
                      <button
                        className="tw-pl-1 tw-text-white tw-border-[#001E64] tw-border-[0.1rem] tw-rounded-full tw-h-10 tw-w-[100%]"
                        aria-label="Customise options"
                      >
                        <span className="tw-pl-1 tw-flex tw-text-[1rem] tw-font-bold tw-items-center tw-justify-between tw-px-2">
                          <span
                            className={
                              sellerInfo.nome === 'Selecione o vendedor'
                                ? 'tw-text-[#AAAAAA]'
                                : 'tw-text-[#001E64]'
                            }
                          >
                            {sellerInfo.nome}
                          </span>
                          <IoIosArrowDown color="#001E64" />
                        </span>
                      </button>
                    </DropdownMenu.Trigger>

                    <DropdownMenu.Portal>
                      <DropdownMenu.Content
                        className=" tw-max-h-[15rem] tw-overflow-scroll tw-overflow-x-hidden tw-px-4 tw-py-2 tw-bg-white tw-rounded-md tw-p-[5px] tw-shadow-md tw-font-[1.1rem]"
                        sideOffset={5}
                      >
                        <DropdownMenu.Item
                          onClick={() => {
                            setSellerInfo({
                              id: '',
                              nome: 'Selecione o vendedor',
                              codigo_produtor: '',
                              login: ''
                            });
                          }}
                          className="hover:tw-bg-slate-200 tw-w-[100%] tw-font-bold tw-cursor-pointer"
                        >
                          Selecione o vendedor:
                        </DropdownMenu.Item>
                        <DropdownMenu.Item
                          onClick={() => {
                            setSellerInfo({
                              id: '',
                              nome: 'Todos',
                              codigo_produtor: '',
                              login: ''
                            });
                          }}
                          className="hover:tw-bg-slate-200 tw-w-[100%] tw-cursor-pointer"
                        >
                          Todos
                        </DropdownMenu.Item>
                        {sellers.map((seller, index) => {
                          return (
                            <DropdownMenu.Item
                              key={index}
                              onClick={() => {
                                setSellerInfo({
                                  ...seller
                                });
                              }}
                              className="hover:tw-bg-slate-200 tw-w-[100%] tw-cursor-pointer"
                            >
                              {seller.nome}
                            </DropdownMenu.Item>
                          );
                        })}
                      </DropdownMenu.Content>
                    </DropdownMenu.Portal>
                  </DropdownMenu.Root>
                </div>
              </div>
            )}

            <div className="tw-flex tw-flex-col tw-w-[100%] tw-gap-3 tw-mt-4 tw-p-4 tw-bg-[#F4F4F4] tw-rounded-md">
              <span className="tw-font-bold">Status do lead</span>
              <RadioGroup.Root
                className="tw-flex tw-gap-2 tw-flex-col"
                defaultValue=""
                value={radiobox}
              >
                <div className="tw-flex tw-gap-2">
                  <RadioGroup.Item
                    className="tw-bg-white tw-border-[0.1rem] tw-border-[#001E64] tw-w-4 tw-h-4 tw-rounded-full tw-shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]"
                    value=""
                    onClick={(e) => {
                      setRadiobox('');
                      setApproach(null);
                      setApproachN2(null);
                      setSchelludingDate(null);
                      setRadioboxVisualization(null);
                      setStatus(null);
                      setSelectedProductNovo('Selecione o produto');
                      setSelectedPlano('Selecione o plano');
                    }}
                    id="r1"
                  >
                    <RadioGroup.Indicator className="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full tw-position-relative after:tw-block after:tw-w-2 after:tw-h-2 after:tw-rounded-full after:tw-bg-[#001E64]" />
                  </RadioGroup.Item>
                  <label className="Label" htmlFor="r1">
                    Todos
                  </label>
                </div>
                <div className="tw-flex tw-gap-2">
                  <RadioGroup.Item
                    className="tw-bg-white tw-border-[0.1rem] tw-border-[#001E64] tw-w-4 tw-h-4 tw-rounded-full tw-shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]"
                    value="visualizados"
                    onClick={(e) => {
                      setRadiobox('visualizados');
                      setRadioboxVisualization('true');
                      setApproach(null);
                      setApproachN2(null);
                      setSchelludingDate(null);
                      setStatus(null);
                      setSelectedProductNovo('Selecione o produto');
                      setSelectedPlano('Selecione o plano');
                    }}
                    id="r10"
                  >
                    <RadioGroup.Indicator className="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full tw-position-relative after:tw-block after:tw-w-2 after:tw-h-2 after:tw-rounded-full after:tw-bg-[#001E64]" />
                  </RadioGroup.Item>
                  <label className="Label" htmlFor="r10">
                    Visualizados
                  </label>
                </div>
                <div className="tw-flex tw-gap-2">
                  <RadioGroup.Item
                    className="tw-bg-white tw-border-[0.1rem] tw-border-[#001E64] tw-w-4 tw-h-4 tw-rounded-full tw-shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]"
                    value="nao_visualizados"
                    onClick={(e) => {
                      setRadiobox('nao_visualizados');
                      setRadioboxVisualization('false');
                      setApproach(null);
                      setApproachN2(null);
                      setSchelludingDate(null);
                      setStatus(null);
                      setSelectedProductNovo('Selecione o produto');
                      setSelectedPlano('Selecione o plano');
                    }}
                    id="r9"
                  >
                    <RadioGroup.Indicator className="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full tw-position-relative after:tw-block after:tw-w-2 after:tw-h-2 after:tw-rounded-full after:tw-bg-[#001E64]" />
                  </RadioGroup.Item>
                  <label className="Label" htmlFor="r9">
                    Não Visualizados
                  </label>
                </div>
                <div className="tw-flex tw-gap-2">
                  <RadioGroup.Item
                    className="tw-bg-white tw-border-[0.1rem] tw-border-[#001E64] tw-w-4 tw-h-4 tw-rounded-full tw-shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]"
                    value="novas_oportunidades"
                    id="r2"
                    onClick={() => {
                      setRadiobox('novas_oportunidades');
                      setApproachN2(null);
                      setRadioboxVisualization(null);
                      setSchelludingDate(null);
                      setSelectedProductNovo('Selecione o produto');
                      setSelectedPlano('Selecione o plano');
                      setStatus('Novas Oportunidades');
                      setApproach(null);
                    }}
                  >
                    <RadioGroup.Indicator className="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full tw-position-relative after:tw-block after:tw-w-2 after:tw-h-2 after:tw-rounded-full after:tw-bg-[#001E64]" />
                  </RadioGroup.Item>
                  <label className="Label" htmlFor="r2">
                    Novas oportunidades
                  </label>
                </div>
                <div className="tw-flex tw-gap-2">
                  <RadioGroup.Item
                    className="tw-bg-white tw-border-[0.1rem] tw-border-[#001E64] tw-w-4 tw-h-4 tw-rounded-full tw-shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]"
                    value="Agendado"
                    onClick={(e) => {
                      setRadiobox('Agendado');
                      setApproach(null);
                      setSchelludingDate(null);
                      setApproachN2(null);
                      setStatus('NovoContato');
                      setRadioboxVisualization(null);
                      setSelectedProductNovo('Selecione o produto');
                      setSelectedPlano('Selecione o plano');
                    }}
                    id="r3"
                  >
                    <RadioGroup.Indicator className="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full tw-position-relative after:tw-block after:tw-w-2 after:tw-h-2 after:tw-rounded-full after:tw-bg-[#001E64]" />
                  </RadioGroup.Item>
                  <label className="Label" htmlFor="r3">
                    Agendado
                  </label>
                </div>
                <div className="tw-flex tw-gap-2">
                  <RadioGroup.Item
                    className="tw-bg-white tw-border-[0.1rem] tw-border-[#001E64] tw-w-4 tw-h-4 tw-rounded-full tw-shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]"
                    value="Agendamento em atraso"
                    onClick={(e) => {
                      setRadiobox('Agendamento em atraso');
                      setApproach(null);
                      setApproachN2(null);
                      setStatus('NovoContato');
                      setStartDate(null);
                      setEndDate(null);
                      setRadioboxVisualization(null);
                      setSchelludingDate(getTime(new Date()));
                      setSelectedProductNovo('Selecione o produto');
                      setSelectedPlano('Selecione o plano');
                    }}
                    id="r4"
                  >
                    <RadioGroup.Indicator className="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full tw-position-relative after:tw-block after:tw-w-2 after:tw-h-2 after:tw-rounded-full after:tw-bg-[#001E64]" />
                  </RadioGroup.Item>
                  <label className="Label" htmlFor="r4">
                    Agendamento em atraso
                  </label>
                </div>
                <div className="tw-flex tw-gap-2">
                  <RadioGroup.Item
                    className="tw-bg-white tw-border-[0.1rem] tw-border-[#001E64] tw-w-4 tw-h-4 tw-rounded-full tw-shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]"
                    value="cotacao_enviada"
                    id="r5"
                    onClick={() => {
                      setRadiobox('cotacao_enviada');
                      setApproach(null);
                      setSchelludingDate(null);
                      setRadioboxVisualization(null);
                      setApproachN2('cotacao');
                      setSelectedProductNovo('Selecione o produto');
                      setSelectedPlano('Selecione o plano');
                      setStatus('EmNegociacao');
                    }}
                  >
                    <RadioGroup.Indicator className="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full tw-position-relative after:tw-block after:tw-w-2 after:tw-h-2 after:tw-rounded-full after:tw-bg-[#001E64]" />
                  </RadioGroup.Item>
                  <label className="Label" htmlFor="r5">
                    Em negociação (Cotação enviada)
                  </label>
                </div>
                <div className="tw-flex tw-gap-2">
                  <RadioGroup.Item
                    className="tw-bg-white tw-border-[0.1rem] tw-border-[#001E64] tw-w-4 tw-h-4 tw-rounded-full tw-shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]"
                    value="proposta_transmitida"
                    id="r6"
                    onClick={() => {
                      setRadiobox('proposta_transmitida');
                      setApproach(null);
                      setSchelludingDate(null);
                      setRadioboxVisualization(null);
                      setSelectedProductNovo('Selecione o produto');
                      setSelectedPlano('Selecione o plano');
                      setApproachN2('transmissao');
                      setStatus('EmNegociacao');
                    }}
                  >
                    <RadioGroup.Indicator className="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full tw-position-relative after:tw-block after:tw-w-2 after:tw-h-2 after:tw-rounded-full after:tw-bg-[#001E64]" />
                  </RadioGroup.Item>
                  <label className="Label" htmlFor="r6">
                    Em negociação (Proposta transmitida)
                  </label>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-2">
                  <div className="tw-flex tw-gap-2">
                    <RadioGroup.Item
                      className="tw-bg-white tw-border-[0.1rem] tw-border-[#001E64] tw-w-4 tw-h-4 tw-rounded-full tw-shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]"
                      value="nao_realizada"
                      id="r7"
                      onClick={() => {
                        setRadiobox('nao_realizada');
                        setApproach(false);
                        setApproachN2(null);
                        setSchelludingDate(null);
                        setRadioboxVisualization(null);
                        setStatus('Concluido');
                        setSelectedProductNovo('Selecione o produto');
                        setSelectedPlano('Selecione o plano');
                      }}
                    >
                      <RadioGroup.Indicator className="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full tw-position-relative after:tw-block after:tw-w-2 after:tw-h-2 after:tw-rounded-full after:tw-bg-[#001E64]" />
                    </RadioGroup.Item>
                    <label className="Label" htmlFor="r7">
                      Concluídos (Venda não realizada)
                    </label>
                  </div>
                  {radiobox === 'nao_realizada' && (
                    <DropdownMenu.Root>
                      <DropdownMenu.Trigger
                        asChild
                        className="sm:tw-w-[48.7%] mb:tw-w-full"
                      >
                        <button
                          className="tw-pl-1 tw-text-white tw-border-[#001E64] tw-border-[0.1rem] tw-rounded-full mb:tw-min-h-[2.5rem] sm:tw-h-10 tw-w-[100%]"
                          aria-label="Customise options"
                        >
                          <span className="tw-pl-1 tw-flex tw-text-[1rem] tw-font-bold tw-items-center tw-justify-between tw-px-2">
                            <span
                              className={
                                selectedFailedReason === 'Selecione o motivo'
                                  ? 'tw-text-[#AAAAAA]'
                                  : 'tw-text-[#001E64]'
                              }
                            >
                              {selectedFailedReason.length >= 20
                                ? selectedFailedReason?.substring(0, 40) + '...'
                                : selectedFailedReason}
                            </span>
                            <IoIosArrowDown color="#001E64" />
                          </span>
                        </button>
                      </DropdownMenu.Trigger>

                      <DropdownMenu.Portal>
                        <DropdownMenu.Content
                          className=" tw-max-h-[15rem] tw-overflow-scroll tw-overflow-x-hidden tw-px-4 tw-py-2 tw-bg-white tw-rounded-md tw-p-[5px] tw-shadow-md tw-font-[1.1rem]"
                          sideOffset={5}
                        >
                          <DropdownMenu.Item
                            onClick={() => {
                              setSelectedFailedReason('Selecione o motivo');
                              setApproachN2(null);
                            }}
                            className="hover:tw-bg-slate-200 tw-w-[100%] tw-font-bold tw-cursor-pointer"
                          >
                            Selecione o motivo:
                          </DropdownMenu.Item>
                          {failedReasons.map((reason, index) => {
                            return (
                              <DropdownMenu.Item
                                key={index}
                                onClick={() => {
                                  setSelectedFailedReason(reason.text);
                                  setApproachN2(reason.status);
                                }}
                                className="hover:tw-bg-slate-200 tw-w-[100%] tw-cursor-pointer"
                              >
                                {reason.text}
                              </DropdownMenu.Item>
                            );
                          })}
                        </DropdownMenu.Content>
                      </DropdownMenu.Portal>
                    </DropdownMenu.Root>
                  )}
                </div>
                <div className="tw-flex tw-flex-col tw-gap-2">
                  <div className="tw-flex tw-gap-2">
                    <RadioGroup.Item
                      className="tw-bg-white tw-border-[0.1rem] tw-border-[#001E64] tw-w-4 tw-h-4 tw-rounded-full tw-shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]"
                      value="venda_realizada"
                      id="r8"
                      onClick={() => {
                        setRadiobox('venda_realizada');
                        setApproach(null);
                        setSchelludingDate(null);
                        setRadioboxVisualization(null);
                        setApproachN2(null);
                        setStatus('Concluido');
                      }}
                    >
                      <RadioGroup.Indicator className="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full tw-position-relative after:tw-block after:tw-w-2 after:tw-h-2 after:tw-rounded-full after:tw-bg-[#001E64]" />
                    </RadioGroup.Item>
                    <label className="Label" htmlFor="r8">
                      Concluídos (Venda realizada)
                    </label>
                  </div>
                  {radiobox === 'venda_realizada' && (
                    <div className="tw-flex sm:tw-gap-6 mb:tw-gap-2 sm:tw-flex-row mb:tw-flex-col">
                      <DropdownMenu.Root>
                        <DropdownMenu.Trigger
                          asChild
                          className="sm:tw-w-[50%] mb:tw-w-full"
                        >
                          <button
                            className="tw-pl-1 tw-text-white tw-border-[#001E64] tw-border-[0.1rem] tw-rounded-full mb:tw-min-h-[2.5rem] sm:tw-h-10 tw-w-[100%]"
                            aria-label="Customise options"
                          >
                            <span className="tw-pl-1 tw-flex tw-text-[1rem] tw-font-bold tw-items-center tw-justify-between tw-px-2">
                              <span
                                className={
                                  selectedProductNovo === 'Selecione o produto'
                                    ? 'tw-text-[#AAAAAA]'
                                    : 'tw-text-[#001E64]'
                                }
                              >
                                {selectedProductNovo}
                              </span>
                              <IoIosArrowDown color="#001E64" />
                            </span>
                          </button>
                        </DropdownMenu.Trigger>

                        <DropdownMenu.Portal>
                          <DropdownMenu.Content
                            className="tw-w-[22rem] tw-px-4 tw-py-2 tw-bg-white tw-rounded-md tw-p-[5px] tw-shadow-md tw-font-[1.1rem]"
                            sideOffset={5}
                          >
                            <DropdownMenu.Item
                              onClick={() => {
                                setSelectedProductNovo('Selecione o produto');
                              }}
                              className="hover:tw-bg-slate-200 tw-w-[100%] tw-font-bold tw-cursor-pointer"
                            >
                              Selecione o produto:
                            </DropdownMenu.Item>
                            {products.map((product, index) => {
                              return (
                                <DropdownMenu.Item
                                  key={index}
                                  onClick={() => {
                                    setSelectedProductNovo(product);
                                    setSelectedPlano('Selecione o plano');
                                  }}
                                  className="hover:tw-bg-slate-200 tw-w-[100%] tw-cursor-pointer"
                                >
                                  {getProductName(product)}
                                </DropdownMenu.Item>
                              );
                            })}
                          </DropdownMenu.Content>
                        </DropdownMenu.Portal>
                      </DropdownMenu.Root>
                      {switchPlans(selectedProductNovo)?.length > 0 && (
                        <DropdownMenu.Root>
                          <DropdownMenu.Trigger
                            asChild
                            className="sm:tw-w-[50%] mb:tw-w-full"
                          >
                            <button
                              className="tw-pl-1 tw-text-white tw-border-[#001E64] tw-border-[0.1rem] tw-rounded-full mb:tw-min-h-[2.5rem] sm:tw-h-10 tw-w-[100%]"
                              aria-label="Customise options"
                            >
                              <span className="tw-pl-1 tw-flex tw-text-[1rem] tw-font-bold tw-items-center tw-justify-between tw-px-2">
                                <span
                                  className={
                                    selectedPlano === 'Selecione o plano'
                                      ? 'tw-text-[#AAAAAA]'
                                      : 'tw-text-[#001E64]'
                                  }
                                >
                                  {selectedPlano}
                                </span>
                                <IoIosArrowDown color="#001E64" />
                              </span>
                            </button>
                          </DropdownMenu.Trigger>

                          <DropdownMenu.Portal>
                            <DropdownMenu.Content
                              className="tw-w-[22rem] tw-px-4 tw-py-2 tw-bg-white tw-rounded-md tw-p-[5px] tw-shadow-md tw-font-[1.1rem]"
                              sideOffset={5}
                            >
                              <DropdownMenu.Item
                                onClick={() => {
                                  setSelectedPlano('Selecione o plano');
                                }}
                                className="hover:tw-bg-slate-200 tw-w-[100%] tw-font-bold tw-cursor-pointer"
                              >
                                Selecione o plano:
                              </DropdownMenu.Item>
                              {switchPlans(selectedProductNovo).map(
                                (plan, index) => {
                                  return (
                                    <DropdownMenu.Item
                                      key={index}
                                      onClick={() => {
                                        setSelectedPlano(plan);
                                      }}
                                      className="hover:tw-bg-slate-200 tw-w-[100%] tw-cursor-pointer"
                                    >
                                      {plan}
                                    </DropdownMenu.Item>
                                  );
                                }
                              )}
                            </DropdownMenu.Content>
                          </DropdownMenu.Portal>
                        </DropdownMenu.Root>
                      )}
                    </div>
                  )}
                </div>
              </RadioGroup.Root>
            </div>
          </div>{' '}
          <div className="tw-flex  sm:tw-flex-row mb:tw-flex-col-reverse tw-w-[100%] tw-mt-2 tw-gap-2 tw-justify-between">
            <div>
              {canFilter && (
                <button
                  onClick={() => {
                    clearFilter();
                  }}
                  className="tw-border-[0.1rem] mb:tw-w-full tw-font-bold tw-text-[red] tw-border-[red] tw-rounded-full  tw-h-[3rem] sm:tw-w-[10rem]"
                >
                  Limpar Filtros
                </button>
              )}
            </div>

            <div className="tw-flex tw-gap-2 sm:tw-flex-row mb:tw-flex-col-reverse">
              <button
                onClick={() => {
                  setIsOpen(false);
                  clearFilter();
                }}
                className="tw-border-[0.1rem] tw-font-bold mb:tw-w-full tw-text-[#001E64] tw-border-[#001E64] tw-rounded-full tw-h-[3rem] sm:tw-w-[8rem]"
              >
                Cancelar
              </button>
              {!loading ? (
                <button
                  className={`tw-rounded-full tw-h-[3rem] mb:tw-w-full sm:tw-w-[8rem] tw-text-white tw-font-bold ${'tw-bg-[#001E64]'}`}
                  onClick={() => {
                    sendFilters();
                  }}
                >
                  {type === 'exportar' ? 'Exportar' : 'Filtrar'}
                </button>
              ) : (
                <button
                  className={`tw-rounded-full tw-h-[3rem] mb:tw-w-full sm:tw-w-[8rem] tw-flex tw-items-center tw-justify-center tw-gap-2 tw-text-white tw-font-bold ${'tw-bg-[#828282]'}`}
                >
                  <svg
                    className="tw-animate-spin tw-h-5 tw-w-5"
                    viewBox="0 0 24 24"
                  >
                    <path
                      xmlns="http://www.w3.org/2000/svg"
                      d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
                      className="spinner_P7sC"
                      fill="orange"
                    />
                  </svg>
                </button>
              )}
            </div>
          </div>
          <DialogRadix.Close asChild>
            <button
              className="tw-text-violet11 tw-hover:bg-violet4 tw-focus:shadow-violet7 tw-absolute tw-top-[10px] tw-right-[10px] tw-inline-flex tw-h-[25px] tw-w-[25px] tw-appearance-none tw-items-center tw-justify-center tw-rounded-full tw-focus:shadow-[0_0_0_2px] tw-focus:outline-none"
              aria-label="Close"
            >
              <Cross2Icon />
            </button>
          </DialogRadix.Close>
        </DialogRadix.Content>
      </DialogRadix.Portal>
    </DialogRadix.Root>
  );
};

export default KanbanFiltersModal;
